import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.div`
    width: 100%;
    background-color: #1c1c1c;
    padding: 30px 0;
    font-size: 14px;
`;

const FooterContent = styled.div`
    max-width: 1000px; // 메인 컨텐츠와 같은 너비
    margin: 0 auto;
`;

const FooterInfoList = styled.ul`
    display: flex;
    list-style: none;
    padding: 0;
    margin-bottom: 15px;
    margin-left: 71.5px;
    margin-right: 20px;
`;

const FooterInfoItem = styled.li`
    margin-right: ${props => props.mr20 ? '20px' : '0'};
    
    a {
        text-decoration: none;
        color: #878585;
        
        &:hover {
        text-decoration: underline;
        }
    }
`;

const Divider = styled.li`
    color: #1c1c1c;
`;

const FooterContactList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin-bottom: 15px;
    margin-left: 71.5px;
`;

const FooterContactItem = styled.li`
    margin-right: ${props => props.mr20 ? '20px' : '0'};
    color: #5a5a5a;
`;

const Copyright = styled.p`
    color: #5a5a5a;
    margin: 0;
    margin-left: 71.5px;
`;

export const Footer = () => {
    return (
        <FooterContainer>
            <FooterContent>
                <FooterInfoList className="fc_info">
                    <FooterInfoItem mr20><a href="/rules/policy">이용약관</a></FooterInfoItem>
                    <Divider className="ccc">|</Divider>
                    <FooterInfoItem><a href="/rules/privacy">개인정보 취급방침</a></FooterInfoItem>
                </FooterInfoList>
                
                <FooterContactList className="fc_info2">
                    <FooterContactItem mr20>서울시 동작구 흑석로 84 중앙대학교 총학생회</FooterContactItem>
                    <FooterContactItem mr20>TEL : 02-881-7371</FooterContactItem>
                    <FooterContactItem mr20>E-MAIL: cau.daheum66@gmail.com</FooterContactItem>
                </FooterContactList>
                
                <Copyright>Copyright 2017 중앙대학교 총학생회 All Rights Reserved</Copyright>
            </FooterContent>
        </FooterContainer>
    );
};

export default Footer;